<div class="container-fluid py-2 py-md-3 px-0">
  @if (event()) {
    <app-event-form
      [initialData]="event()!"
      [availableOrganizations]="availableOrganizations()"
      [lockOrganization]="true"
      title="Modifica evento"
      submitLabel="Aggiorna"
      (formSubmit)="onSubmit($event)"
      (cancel)="onCancel()"></app-event-form>
  } @else {
    <div class="text-center py-5">Caricamento evento...</div>
  }
</div>

